var requisitionDisplaySelectedFilter = /** @class */ (function () {
    function requisitionDisplaySelectedFilter() {
        this.searchString = "";
        this.clientOrBU = [],
            this.roleList = [],
            this.requisitionTypes = [],
            this.requisitionStates = [],
            this.requisitionNums = [],
            this.recruiters = [],
            this.jobTypes = [],
            this.workLocationIds = [],
            this.selectedFilterSort = "";
        this.showDisplayFilterIconFlag = true;
    }
    return requisitionDisplaySelectedFilter;
}());
export { requisitionDisplaySelectedFilter };
;
//# sourceMappingURL=requisition-display-selected-filter.model.js.map